import styled from 'styled-components'

export const LightboxContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: 0 12px;
`
export const ImageContainer = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  max-width: 1140px;
  max-height: calc(100vh - 40px);
  background-color: white;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  border-radius: 8px;

  .lightbox-image,
  .lightbox-image img {
    width: auto;
    max-height: 800px;
    object-fit: contain;
    object-position: center;
    margin: 0;
  }
`
export const CloseButton = styled.button`
  position: absolute;
  display: flex;
  background: transparent;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  font-weight: 400;
  font-style: normal;
  top: 4px;
  right: 4px;
  z-index: 1000;
  border: none;
  border-radius: 4px;
  transition: background-color 0.3s ease;
  cursor: pointer;
  color: #21154a;

  &:hover {
    background-color: rgba(128, 128, 128, 0.1);
    backdrop-filter: blur(5px);
  }
`
